// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__AlfsN","truncatedText":"styles_truncatedText__bW4yH","fullText":"styles_fullText__KzyJL","textContainer":"styles_textContainer__TWTwP"};